import { getDamagedTabsQueryParams } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getParticipantsTabs/getParticipantsTabs.type';
import { getDamagedTabsQueryFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getParticipantsTabs/getParticipantsTabsQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getParticipantsTabsQueryOptions = (
  params: getDamagedTabsQueryParams,
) =>
  queryOptions({
    queryKey: ['get_damaged_tabs', params],
    queryFn: () => getDamagedTabsQueryFunction(params),
  });
